<div
  (click)="disabled || FileUpload.click()"
  style="position: relative"
  class="dropzone"
  appFiledrop
  (filesDropped)="handleNewFiles($event)"
  (filesHovered)="dropzoneState($event)"
  [ngClass]="{active: dropzoneActive, small: size == 'small', disabled: disabled}"
>
  <div class="centered">
    <div class="drop-icon-hint-text">Drag & Drop oder klicken</div>

    <div class="upload-icon"></div>

    <div class="drop-hint-text">{{ message }}</div>
    <div *ngIf="maxFileSize" class="drop-file-info">({{ accept }}) Maximale Größe - {{ maxFileSizeMb }}</div>
  </div>
</div>

<div style="width: 100%; display: table; margin-top: 1rem">
  <div class="centered">
    <input type="file" #FileUpload [accept]="accept" hidden (click)="resetFileInput()" (change)="handleNewFiles($event.target.files)" />
  </div>
</div>
